import { Col, Row, Container } from 'react-bootstrap';

interface Props {
  isInFixedFooter?: boolean;
}

const COPYRIGHT_TEXT = 'Copyright © 一般社団法人 授業目的公衆送信補償金等管理協会 All Rights Reserved.';

const CopyrightNotice: React.FC<Props> = ({ isInFixedFooter = false }) => {
  if (isInFixedFooter) {
    return <div className="fixed-footer-copy">{COPYRIGHT_TEXT}</div>;
  }

  return (
    <Container className="mt-4 mb-4">
      <Row>
        <Col className="text-black-50 text-center">
          <small>{COPYRIGHT_TEXT}</small>
        </Col>
      </Row>
    </Container>
  );
};

export default CopyrightNotice;
